<template>
  <div>
    <p v-if="total === 0">Nenhum registro encontrado</p>
    <div class="table-responsive" v-else>
      <table class="table">
        <!--
        <div class="validation-count">
          <div class="subtitle">{{ total }} {{ total > 1 ? 'resultados' : 'resultado' }}</div>
          <div v-if="this.validations">
            <b-form-checkbox
              class="subtitle"
              id="checkbox-serviceStatus"
              v-model="serviceStatus"
              @change="serviceStatusSelected"
            >
              Desabilitar <b-badge pill variant="warning">link criado</b-badge>
            </b-form-checkbox>
          </div>
        </div>
        -->
        <thead class="thead-light">
          <tr>
            <th scope="col" class="text-right">
              Data
            </th>
            <th scope="col">
            </th>
            <th scope="col">
              Cliente
            </th>
            <th scope="col">
              Email
            </th>
            <th scope="col">
              Telefone
            </th>
            <th scope="col">
              Loja
            </th>
            <th scope="col">
              Status
            </th>
            <th scope="col">
            </th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="tx in txs.list" v-bind:key="tx.id">
          <th scope="row">
            <div>
              <router-link :to="{name: 'OrderValidation', params: { txid: tx.uuid }}"><strong>#{{ tx.id | numeral('00000') }}</strong></router-link>
              <!-- <router-link v-else :to="{name: 'CustomerServiceDetailsNew', params: { txid: tx.uuid }}"><strong>#{{ tx.id | numeral('00000') }}</strong></router-link> -->
            </div>
          </th>
          <td>
            <div class="subtitle">{{tx.dateCreated | moment}} - {{tx.dateCreated | moment-hour}}</div>
          </td>
          <td>
            <div>
              <div class="subtitle"><strong>{{tx.buyerName}} <b-badge pill :variant="(tx.rating === 'A' || tx.rating === 'B') ? 'success' : ((tx.rating === 'D' || tx.rating === 'E') ? 'danger' : 'warning')">{{ tx.rating }}</b-badge></strong></div>
            </div>
          </td>
          <td>
            <div class="subtitle">{{ tx.buyerEmail }}</div>
          </td>
          <td>
            <div class="subtitle">{{ tx.buyerPhone }}</div>
          </td>
          <td>
            <div class="subtitle"><strong>{{ tx.sellerName }}</strong></div>
          </td>
          <td>
            <div class="subtitle">
              <!-- <template v-if="tx.installment">
                <div class="pix-container">
                  <span v-if="tx.installment.pix" class="waiting-pix">Aguardando PIX</span>
                  <span v-if="tx.installment.pix" class="waiting-pix-time">{{ pixCodeTimeExpiresCountdown(tx.installment.pixDateExpire) }}</span>
                </div>
              </template> -->
              <template v-if="tx.firstPaymentRequired">
                  <div class="pix-container">
                    <span v-if="tx.firstPaymentDateExpiry && new Date() < new Date(tx.firstPaymentDateExpiry)" class="waiting-pix">Aguardando PIX</span>
                    <span v-else class="expired-pix">PIX expirado</span>
                    <div  class="waiting-pix-time">
                      <span v-if="new Date() < new Date(tx.firstPaymentDateExpiry)">Expira às</span>
                      <span v-if="tx.firstPaymentDateExpiry" >{{ checkExpiredTimer(tx.firstPaymentDateExpiry) }}</span>
                    </div>
                  </div>
              </template>
              <b-badge v-else-if="tx.serviceStatus" pill :variant="(tx.modifiedCurrentStep === 'Pix Pago') ? 'Pix confirmado' : (tx.serviceStatus === 'Link criado') ? 'warning' : ((tx.serviceStatus === 'Documentos enviados') ? 'success' : (tx.serviceStatus === 'Resposta cliente') ? 'danger' : 'info')">
                {{ tx.serviceStatus }}
              </b-badge>
              <strong v-else>{{ tx.currentStep }}</strong>
            </div>
          </td>
          <td>
            <button class="btn bf-btn-whatsapp" @click="showWhatsappScreen(tx)">
              <i class="fa fa-whatsapp" style="margin: 0; color: #FFF;"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <!-- <b-pagination size="md" align="center" :total-rows="total" v-model="currentPage" :per-page="max" @change="fetchCustomerData"></b-pagination> -->
    <div class="text-center" v-if="total > 9 && max < total">
      <button class="btn bf-btn-loadmore" @click="handleLoadMore()">
        {{ loading ? 'Carregando...' : 'Carregar mais' }}
      </button>
    </div>
  </div>
</template>

<script>
import Button from '../button/Button.vue'
import Input from '../form/Input.vue'
import moment from 'moment-timezone'

export default {
  props: {
    'validations': {
      default: true
    },
    typeList: {
      type: String
    }
  },
  components: {
    'input-component': Input,
    'button-component': Button
  },
  data () {
    return {
      txs: [],
      currentPage: 1,
      max: 10,
      total: 0,
      loading: false,
      openScreen: false,
      phoneNumber: null,
      name: '',
      seller: null,
      serviceStatus: false,
      orderList: null,
      stepList: null,
      date: null,
      textDay: null,
      textHour: '00',
      textMinute: '00',
      textSecond: '00',
      clearPixCount: null,
      pixExpired: false
    }
  },
  destroyed () {
    clearInterval(this.clearPixCount)
    this.txs = []
  },
  mounted () {
    // this.clearPixCount = setInterval(() => {
    //   this.pixCodeTimeExpiresCountdown()
    // }, 1000)

    switch (this.typeList) {
      case 'validation':
        this.fetchValidationData(1)
        break
      case 'customer':
        this.fetchCustomerData(1)
        break
      // case 'validationPIX':
      //   this.getPixList(1)
      //   break
      default:
        break
    }

    this.$root.$on('loadFilterData', (payload) => {
      this.name = payload.name
      this.seller = payload.seller
      this.stepList = payload.transactionStepSelected
      this.orderList = payload.orderBySelected
      this.date = payload.date

      switch (this.typeList) {
        case 'validation':
          this.fetchValidationData(1)
          if (!this.validations) {
            this.$root.$emit('openCollapseValidationDocument', this.stepList)
          } else {
            this.$root.$emit('openCollapseValidation', this.stepList)
          }
          break
        case 'customer':
          this.fetchCustomerData(1)
          this.$root.$emit('openCollapseClosed')
          break
        // case 'validationPIX':
        //   this.getPixList(1)
        //   this.$root.$emit('openCollapsePix')
        //   break
        default:
          break
      }
    })
  },
  methods: {
    checkExpiredTimer (timer) {
      if (new Date() > new Date(timer)) {
        this.pixExpired = true
      } else {
        return moment(timer).format('HH:mm')
      }
    },
    showWhatsappScreen (lineInfo) {
      this.$emit('uuid', lineInfo.uuid)
      this.$emit('buyerPhone', lineInfo.buyerPhone)
      this.$emit('whatsappOpen', true)
      this.$emit('customerName', lineInfo.buyerName)
      this.$emit('customerProfilePicture', lineInfo.profilePicture)
      this.$emit('seller', lineInfo.sellerName)
      this.$emit('reference', lineInfo.installment)
    },
    handleLoadMore () {
      this.loading = true
      this.max += 10
      switch (this.typeList) {
        case 'validation':
          this.fetchValidationData()
          break
        case 'customer':
          this.fetchCustomerData()
          break
        // case 'validationPIX':
        //   this.getPixList()
        //   break
        default:
          break
      }
    },
    pixCodeTimeExpiresCountdown (dateExpire) {
      var strTime = ''
      if (new Date() > new Date(dateExpire)) {
        strTime = '00:00:00'
        return strTime
      }
      const dtExp = new Date(dateExpire)
      const countDate = dtExp.getTime()
      const now = new Date().getTime()
      const gap = countDate - now

      const second = 1000
      const minute = second * 60
      const hour = minute * 60
      const day = hour * 24

      this.textDay = Math.floor(gap / day)
      this.textHour = Math.floor((gap % day) / hour)
      this.textMinute = Math.floor((gap % hour) / minute)
      this.textSecond = Math.floor((gap % minute) / second)

      // if (this.textDay > 0) {
      //   if (strTime !== '') strTime += ', '
      //   strTime += (this.textDay > 1) ? this.textDay + ' dias' : '1 dia'
      // }
      // if (this.textHour > 0) {
      //   if (strTime !== '') strTime += ', '
      //   strTime += (this.textHour > 1) ? this.textHour + ' horas' : '1 hora'
      // }
      // if (this.textMinute > 0) {
      //   if (strTime !== '') strTime += ', '
      //   strTime += (this.textMinute > 1) ? this.textMinute + ' min ' + this.textSecond : '1 min ' + this.textSecond
      // }

      strTime += this.textHour < 10 ? `0${this.textHour}:` : `${this.textHour}:`
      strTime += this.textMinute < 10 ? `0${this.textMinute}:` : `${this.textMinute}:`
      strTime += this.textSecond < 10 ? `0${this.textSecond}` : this.textSecond

      return strTime
    },
    getPixList: function (val) {
      var page = val || this.currentPage
      this.$http.get('api/validations/pix-validations-list', {
        params: {
          offset: this.max * (page - 1),
          max: this.max
        }
      })
        .then(function (res) {
          this.txs = res.data
          this.total = res.data.total
          this.loading = false
          this.$root.$emit('openCollapsePix')
        })
        .catch(function (res) {
          console.error('Error')
          console.error(res)
          this.loading = false
        })
    },
    fetchValidationData: function (val) {
      var page = val || this.currentPage
      var nameValue = ''
      if (this.name) {
        nameValue = this.removeDots(this.name)
      }
      var dataInicial = null
      var dataFinal = null
      if (this.date) {
        dataInicial = moment(this.date.start).format('YYYY-MM-DD')
        dataFinal = moment(this.date.end).format('YYYY-MM-DD')
      }
      this.$http.get('api/validations', {
        params: {
          offset: this.max * (page - 1),
          max: this.max,
          name: nameValue,
          order: this.orderList,
          validations: this.validations,
          serviceStatus: this.serviceStatus,
          seller: this.seller,
          startdate: dataInicial,
          enddate: dataFinal
        }})
        .then(function (res) {
          this.txs = res.data
          this.total = res.data.total
          this.loading = false

          if (!this.validations) {
            this.$root.$emit('openCollapseValidationDocument', this.stepList)
          } else {
            this.$root.$emit('openCollapseValidation', this.stepList)
          }
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.loading = false
        })
    },
    fetchCustomerData: function (val) {
      moment.locale('pt-br')
      var page = val || this.currentPage

      var dataInicial = null
      var dataFinal = null
      if (this.date) {
        dataInicial = moment(this.date.start).format('YYYY-MM-DD')
        dataFinal = moment(this.date.end).format('YYYY-MM-DD')
      }
      var nameValue = ''
      if (this.name) {
        nameValue = this.removeDots(this.name)
      }
      this.$http
        .get('api/customerservice', {
          params: {
            offset: this.max * (page - 1),
            max: this.max,
            name: nameValue,
            order: this.orderList,
            step: this.stepList,
            seller: this.seller,
            startdate: dataInicial,
            enddate: dataFinal

          }
        })
        .then(function (res) {
          this.txs = res.data
          this.total = res.data.total
          this.loading = false
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.loading = false
        })
    },
    removeDots: function (name) {
      return name.replace(/\.|-|\(|\) |\)/g, '')
    },
    convertTime: function (val) {
      var seconds = Math.floor(val % 60).toString()
      var minutes = Math.floor(val / 60).toString()
      if (seconds.length === 1) {
        seconds = '0' + seconds
      }
      return minutes + 'm' + seconds + 's'
    },
    extractHostname: function (url) {
      var hostname

      if (url) {
        if (url.indexOf('://') > -1) {
          hostname = url.split('/')[2]
        } else {
          hostname = url.split('/')[0]
        }

        hostname = hostname.split(':')[0]
        hostname = hostname.split('?')[0]
      }

      return hostname
    }
  },
  computed: {
  },
  watch: {
    date () {
      switch (this.typeList) {
        case 'validation':
          this.fetchValidationData(1)
          if (!this.validations) {
            this.$root.$emit('openCollapseValidationDocument', this.stepList)
          } else {
            this.$root.$emit('openCollapseValidation', this.stepList)
          }
          break
        case 'customer':
          this.fetchCustomerData(1)
          this.$root.$emit('openCollapseClosed')
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/variaveis.scss";
  @import "../../../assets/scss/mixins.scss";
  @import "../../../assets/scss/card.scss";
  .card-user {
    .avatar {
      width: 40px;
    }
    .card-invite-body {
      top: 102px;
    }
  }
  .img-profile {
    float: left;
    margin-right:1rem;
  }
  .validation-count {
    padding: 12px !important;
    display: flex !important;
    justify-content: space-between !important;
  }
  .bf-btn-whatsapp, .bf-btn-loadmore {
    background: #1C56E0;
    color: #FFF;
  }
  .pix-container {
    display: flex;
    width: 200px;
    align-items: center;
    .waiting-pix {
      color: #F09B1B;
      background-color: rgba(240, 155, 27, 0.2);
      font-weight: bold;
      padding: 5px 15px;
      border-radius: 5px;
    }
    .expired-pix {
      color: #BA1B22;
      background-color: #F1D1D3;
      font-weight: bold;
      padding: 5px 15px;
      border-radius: 5px;
    }
    .waiting-pix-time {
      color: #F09B1B;
      display: flex;
      flex-direction: column;
      margin-left: 3px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/order/OrdersList.vue